import { writable } from "svelte/store"
import type { ContextMenuConfig } from "./ContextMenuTypes"

export const ctxMenuStore = writable<ContextMenuConfig>({
	isOpen: false,
})
